// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"74361d4e","239":"de57f274","977":"698748b6"}[chunkId] + ".chunk.js";
};